<div class="policy-shell container">
	<article class="entry">
		<header class="policy-header">
			<nav class="policy-nav">
				<a class="textlink" [href]="'/'" role="menuitem">
					portfolio
				</a>
				<a class="textlink" [href]="'/blog'" role="menuitem" >
					blog
				</a>
				<div class="nav-right">
					<app-logo-context-menu></app-logo-context-menu>
				</div>
			</nav>
			<h1>Privacy Policy</h1>
			<p class="last-updated">Last Updated: July 13, 2026</p>
		</header>
		<div class="policy-content entry-content">
			<section>
				<h2>1. Introduction</h2>
				<p>
					We are committed to protecting your privacy. This Privacy Policy explains how we collect, use,
					disclose, and otherwise process personal information in connection with our website, mobile
					applications, and related services (collectively, the "Services").
				</p>
				<p>
					Please read this Privacy Policy carefully. By accessing and using our Services, you acknowledge
					that you have read, understood, and agree to be bound by all the terms of this Privacy Policy.
				</p>
			</section>
			<section>
				<h2>2. Information We Collect</h2>
				<h3>2.1 Information You Provide</h3>
				<p>
					We collect information you voluntarily provide, including:
				</p>
				<ul>
					<!--li><strong>Account Information:</strong> Name, email address, password, and profile information when you create an account</li-->
					<li><strong>Communication Information:</strong> Name, email address, messages, inquiries, and feedback you send us</li>
					<!--li><strong>Payment Information:</strong> Billing address, payment method details processed through secure third-party payment processors</li-->
					<li><strong>Content:</strong> Any content you upload, create, or share through our Services</li>				
				</ul>
				<h3>2.2 Information Collected Automatically</h3>
				<p>
					When you use our Services, we automatically collect certain information:
				</p>
				<ul>
					<li><strong>Device Information:</strong> Device type, operating system, unique device identifiers, and mobile network information</li>
					<li><strong>Usage Information:</strong> Features accessed, content viewed, search queries, and interaction patterns</li>
					<li><strong>Location Information:</strong> Approximate location based on IP address (unless you've disabled this)</li>
					<li><strong>Cookies and Tracking Technologies:</strong> We use cookies, web beacons, and similar technologies to recognize you and improve your experience</li>
				</ul>
				<h3>2.3 Information from Third Parties</h3>
				<p>
					We may receive information about you from third parties, including:
				</p>
				<ul>
					<li>Social media platforms (if you link your account to our Services)</li>
					<li>Analytics providers</li>
					<li>Marketing and advertising partners</li>
					<li>Data brokers and publicly available sources</li>
				</ul>
			</section>
			<section>
				<h2>3. How We Use Your Information</h2>
				<p>
					We use the information we collect for various purposes:
				</p>
				<ul>
					<li><strong>Service Delivery:</strong> To provide, maintain, and improve our Services</li>
					<!--li><strong>Account Management:</strong> To create and manage your account, authenticate your identity, and provide customer support</li-->
					<li><strong>Communication:</strong> To send you service-related announcements, updates, and respond to your inquiries</li>
					<li><strong>Marketing:</strong> To send promotional materials, newsletters, and marketing communications (with your consent)</li>
					<li><strong>Analytics:</strong> To analyze usage patterns and improve user experience</li>
					<li><strong>Legal Compliance:</strong> To comply with applicable laws, regulations, and legal processes</li>
					<li><strong>Fraud Prevention:</strong> To detect, investigate, and prevent fraudulent activities and security incidents</li>
				</ul>
			</section>
			<section>
				<h2>4. How We Share Your Information</h2>
				<p>
					We do not sell your personal information. However, we may share your information with:
				</p>
				<ul>
					<li>
						<strong>Service Providers:</strong> Third-party vendors who perform services on our behalf (hosting, payment processing, analytics).  Those services include:
						<ul>
							<li>Supabase</li>
							<li>Google Analytics</li>
							<li>Gmail</li>
							<li>Contentful</li>
						</ul>
					</li>
					<li><strong>Legal Requirements:</strong> When required by law or to protect our legal rights</li>
					<li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or sale of assets</li>
					<li><strong>With Your Consent:</strong> When you explicitly authorize us to share your information with third parties</li>
				</ul>
			</section>
			<section>
				<h2>5. Data Security</h2>
				<p>
					We implement appropriate technical, administrative, and physical safeguards to protect your personal
					information against unauthorized access, alteration, disclosure, or destruction. However, no method
					of transmission over the Internet is 100% secure. We cannot guarantee absolute security.
				</p>
				<p>
					You are responsible for maintaining the confidentiality of your account credentials and are liable
					for all activities that occur under your account.
				</p>
			</section>
			<section>
				<h2>6. Your Rights and Choices</h2>
				<h3>6.1 Access and Correction</h3>
				<p>
					You may request access to, or correction of, your personal information by contacting us at create&commat;nhdsgn.com.
				</p>
				<h3>6.2 Marketing Communications</h3>
				<p>
					You can opt out of receiving promotional emails by clicking the &ldquo;unsubscribe&rdquo; link in any marketing email or by contacting us directly at create&commat;nhdsgn.com.
				</p>
				<h3>6.3 Cookies</h3>
				<p>
					You can control cookies through your browser settings. Note that disabling cookies may affect the
					functionality of our Services.
				</p>
				<h3>6.4 Data Deletion</h3>
				<p>
					You may request deletion of your account and associated personal information, subject to certain
					legal and operational exceptions.
				</p>
			</section>
			<section>
				<h2>7. Retention of Information</h2>
				<p>
					We retain personal information for as long as necessary to provide our Services, comply with legal
					obligations, and resolve disputes. The retention period may vary depending on the context of processing.
				</p>
			</section>
			<section>
				<h2>8. Third-Party Links</h2>
				<p>
					Our Services may contain links to third-party websites and services. This Privacy Policy does not apply
					to third-party services, and we are not responsible for their privacy practices. We encourage you to
					review the privacy policies of any third-party services before providing your information.
				</p>
			</section>
			<section>
				<h2>9. Children's Privacy</h2>
				<p>
					Our Services are not intended for children under the age of 13. We do not knowingly collect personal
					information from children under 13. If we become aware that we have collected personal information from
					a child under 13, we will promptly delete such information and terminate the child's account.
				</p>
			</section>
			<section>
				<h2>10. International Data Transfers</h2>
				<p>
					Your information may be transferred to, stored in, and processed in countries other than your country
					of residence, which may have data protection laws different from your home country. By using our Services,
					you consent to the transfer of your information to countries outside your country of residence.
				</p>
			</section>
			<section>
				<h2>11. Contact Us</h2>
				<p>
					If you have questions about this Privacy Policy or our privacy practices, please contact us at:
				</p>
				<div class="contact-info">
					<p>Email: create&commat;nhdsgn.com</p>
				</div>
			</section>
			<section>
				<h2>12. Changes to This Privacy Policy</h2>
				<p>
					As this website evolves, additional tools for managing communication preferences may become available. This Privacy Policy will be updated to reflect those changes. We will notify you of any material changes by posting the updated Privacy Policy on our website and updating the "Last Updated" date. Your continued use of our Services after such changes constitutes your acceptance of the updated Privacy Policy.
				</p>
			</section>
		</div>
	</article>
</div>
<nh-footer></nh-footer>